<template>
    <div>
        <template v-if="batch_report === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Batch Report </h1>
            </div>
            <div class="peopple-managment-main">
                <div class="people-management-inner-content pt-5 pb-0 pl-5 pr-5">
           
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="label block-label"> From Date </label>
                                <datepicker name="from_date" v-model="from_date" input-class="datepicker" :bootstrap-styling="true" placeholder="From Date"></datepicker>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="label block-label"> To Date </label>
                                <datepicker name="to_date" v-model="to_date" input-class="datepicker" :bootstrap-styling="true" placeholder="To Date"></datepicker>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="form-group align-right">
                                <br>
                                <button @click="getBatchReport" v-if="!showBtn" class="btn btn-primary">Search</button>
                                <button @click="filterTable" v-if="showBtn" class="btn btn-primary">Search</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tab-content" id="myTabContent">
                <div v-show="!hasPer" class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                    <div class="empty-main pt-0" style="height: 100px">
                        <div class="empty-inner">
                            <img src="/images/new_empty_payments.png" alt="" />
                            <h2> Hi, {{user}}! </h2>
                            <p> Select your requirements and export your desired report </p>
                        </div>
                    </div>
                </div>
                <div v-show="hasPer">
                    <div class="mt-3 mb-3 tbl-fiters-search-area  hidden-xs" v-if="export_batch_report === true">
                        <div class="field-box export-attendance">
                            <button class="btn btn-primary export" @click="exportReport">Export Report</button>
                        </div>
                    </div>


                    <div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
                        <table id="BatchReportTable" class="table" style="width:100%">
                            <thead>
                                <tr>
                                    <th style="display: none">ID</th>
                                    <th>Date</th>
                                    <th>Balanced Received</th>
                                    <th>Batch Count</th>
                                    <th>Batch Amount</th>
                                    <th>Batch Amount Transfered</th>
                                    <th>Batch Amount Failed</th>
                                    <th>Total TXN Count</th>
                                    <th>Success TXN Count</th>
                                    <th>Reject TXN Count</th>
                                    <th>Remaining Balance</th>
                                </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="batch_report === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="batch_report === false">
            <notAllowed></notAllowed>
        </template>

    </div>
</template>

<script>
    var dtTable = null;
    export default {
        data() {
            return {
               
                from_date :     moment().format(),
                to_date :     moment().format(),
                // filter data
                vendor_categories : null,
                hasPer: false,
                user: '',
                batch_report: null,
                export_batch_report: null,
                showBtn: false
            };
        },
        mounted() {
            this.can('batch_report|export_batch_report').then(result => {
                console.log(result);
                this.batch_report = result.batch_report;
                this.export_batch_report = result.export_batch_report;
                this.user = result.user_name;
            }).then(result => {
                if(this.batch_report == true){
                    // this.loadFiltersData();
                }
            });
        },
        methods: {
    
            filterTable(){
                this.$Progress.start();
                dtTable.draw();
                this.$Progress.finish();
            },
            exportReport: function(){
                this.$Progress.start();
                var formData = {
                    'to_date': moment(this.to_date).format('YYYY-MM-DD'),
                    'from_date': moment(this.from_date).format('YYYY-MM-DD'),
                    
                }
                axios.post('/api/batch_export', formData,{
                    responseType: 'blob'
                })
                .then(res => {
                    if(res.status == 200){
                        const url = URL.createObjectURL(new Blob([res.data], {
                        type: 'application/vnd.ms-excel'
                    }))

                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'BatchReport.xlsx')
                    document.body.appendChild(link)
                    link.click()
                    this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load data');
                });
            },
            getBatchReport: function(){
                console.log('start')
                this.$Progress.start();
                var that = this;
                dtTable = $('#BatchReportTable').DataTable({
                    sDom: '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                     "paging": false,
                     "bInfo" : false,
                    ajax: {
                        "url": "api/batchReportDetails",
                        "data": function (d) {
                            d.from_date = moment(that.from_date).format('YYYY-MM-DD');
                            d.to_date = moment(that.to_date).format('YYYY-MM-DD');
                        },
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records", 
                   },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {render: function(data,type,full){
                            console.log(full)
                            if(full.Date != null){
                                return full.Date;
                            }else{
                                return "---";
                            }
                        }},
                        {render: function(data,type,full){
                            if(full.Balance != null){
                                return full.Balance;
                            }else{
                                return "---";
                            }
                        }},
                        {render: function(data,type,full){
                            if(full.UploadBatch != null){
                                return full.UploadBatch;
                            }else{
                                return "---";
                            }
                        }},
                        {render: function(data,type,full){
                            if(full.BatchProcess != null){
                                return full.BatchProcess;
                            }else{
                                return "---";
                            }
                        }},
                        {render: function(data,type,full){
                            if(full.BatchAmountTransfered != null){
                                return full.BatchAmountTransfered;
                            }else{
                                return "---";
                            }
                        }},
                        {render: function(data,type,full){
                            if(full.BatchAmountFailed != null){
                                return full.BatchAmountFailed;
                            }else{
                                return "---";
                            }
                        }},
                        {render: function(data,type,full){
                            if(full.TotalCount != null){
                                return full.TotalCount;
                            }else{
                                return "---";
                            }
                        }},
                        {render: function(data,type,full){
                            if(full.CountSuccess != null){
                                return full.CountSuccess;
                            }else{
                                return "---";
                            }
                        }},
                         {render: function(data,type,full){
                            if(full.CountReject != null){
                                return full.CountReject;
                            }else{
                                return "---";
                            }
                        }},
                        {render: function(data,type,full){
                            if(full.AvailBalance != null){
                                return full.AvailBalance;
                            }else{
                                return "---";
                            }
                        }},
                  
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (res) => {
                        that.hasPer = true;
                        that.showBtn = true;
                        setTimeout(function(){
                            $('select.selectpicker').selectpicker();
                        },300);
                        that.$Progress.finish();
                    }
                });
            }
        },
        created() {
            //
        }
    }
</script>
